
import React from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import SolutionsSection from './components/SolutionsSection';
import ClientsSection from './components/ClientsSection';
import ResultsSection from './components/ResultsSection';
import FAQSection from './components/FAQSection';
import PartnersSection from './components/PartnersSection';
import ContactCTASection from './components/ContactCTASection';
import DiagnosticForm from './components/DiagnosticForm';
import Footer from '../../components/feature/Footer';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <ClientsSection />
      <AboutSection />
      <SolutionsSection />
      <ResultsSection />
      <DiagnosticForm />
      <PartnersSection />
      <FAQSection />
      <ContactCTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
